var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.mode === 'customize')?_c('page-list',{attrs:{"list":_vm.list,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"columns":_vm.columns}}):_c('a-alert',{attrs:{"message":_vm.$t('k8s.text_279'),"banner":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }